import routes from '../routes';
// import API from '../api/api';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import DashboardStyles from '../styles/Dashboard';
import { Workspace, Header, Footer } from '../components';
import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
// import { MobileBreakpoint } from '../styles/variables';
import { Route, Switch, Redirect } from 'react-router-dom';

// const userRole = localStorage.getItem('userRole');

function resizeDispatch() {
  if (typeof (Event) === 'function') {
    window.dispatchEvent(new Event('resize'));
  } else {
    const evt = window.document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }
}

class Dashboard extends Component {

  constructor(props) {
    super(props);
    this.state = {
      opened: true,
      notificationsOpen: false,
      type: 'light',
      direction: 'ltr',
      openSpeedDial: false,
      isNewNotification: false,
      mainMinHeight: window.innerHeight,
    };
  }

  mediaMatcher = matchMedia(`(max-width: 960px)`);

  handleDrawerToggle = () => {
    this.setState({ opened: !this.state.opened });
    resizeDispatch()
  };

  handleNotificationToggle = () => {
    this.setState({ notificationsOpen: !this.state.notificationsOpen });
  }

  handleSpeedDialOpen = () => {
    this.setState({ openSpeedDial: true });
  };

  handleSpeedDialClose = () => {
    this.setState({ openSpeedDial: false });
  };

  componentDidMount() {

    if (this.mediaMatcher.matches) this.setState({ opened: false });

    this.mediaMatcher.addListener(match => {
      setTimeout(() => {
        if (match.matches) {
          this.setState({ opened: false })
        } else {
          this.setState({ opened: true })
        }
      }, 300)
    })

    this.unlisten = this.props.history.listen(() => {
      if (this.mediaMatcher.matches) this.setState({ opened: false });
      document.querySelector('#root > div > main').scrollTop = 0;
    });

    window.history.pushState(null, document.title, window.location.href);
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, document.title, window.location.href);
    });

  }

  componentWillUnmount() {
    this.unlisten();
    this.mediaMatcher.removeListener(match => {
      setTimeout(() => {
        if (match.matches) {
          this.setState({ opened: false })
        } else {
          this.setState({ opened: true })
        }
      }, 300)
    });
  }

  render() {
    const { classes } = this.props;
    const { opened } = this.state;

    const getRoutes = (
      <Switch>
        {routes.items.map((item, index) => (
          item.type === 'external' ? <Route exact path={item.path} component={item.component} name={item.name} key={index} /> :
            item.type === 'submenu' ? item.children.map(subItem => <Route exact path={`${item.path}${subItem.path}`} component={subItem.component} name={subItem.name} />) :
              <Route exact path={item.path} component={item.component} name={item.name} key={index} />
        ))}
        <Redirect to="/404" />
      </Switch>
    )

    return (
      <Fragment>
        <Header
          logoAltText="Mapster Admin Dashboard"
          logo={`/static/images/mapster.png`}
          toggleDrawer={this.handleDrawerToggle}
          toogleNotifications={this.handleNotificationToggle}
          isNewNotification={this.state.isNewNotification}
        />
        <div className={classNames(classes.panel, 'theme-dark')} id="mainDiv" style={{ minHeight: this.state.mainMinHeight+'px' }}>
          <Workspace opened={opened}>
            {getRoutes}
          </Workspace>
        </div>
        <Footer/>
      </Fragment>
    )
  }
}

Dashboard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(DashboardStyles)(Dashboard);



// WEBPACK FOOTER //
// ./src/containers/Dashboard.js